export default __webpack_public_path__ + "static/media/certificates_3.d3c78308.jpeg";